export interface SiteConfig {
  business: {
    name: string;
    location: string;
    email: string;
    phone: string;
    description: string;
  };
  about: {
    title: string;
    content: string;
    mission: string;
    vision: string;
    experience: string;
    image: string;
    stats: {
      projectsCompleted: string;
      clientSatisfaction: string;
      yearsExperience: string;
      teamMembers: string;
    };
  };
  services: {
    title: string;
    items: Array<{
      title: string;
      description: string;
      icon?: string;
    }>;
  };
  contact: {
    title: string;
    description: string;
  };
}

export const defaultConfig: SiteConfig = {
  business: {
    name: "eBuild and Construct",
    location: "Australia",
    email: "Ryan@ebuildandconsult.com",
    phone: "Ryan - Builder: 0416758756",
    description: "Transforming visions into reality"
  },
  about: {
    title: "About Us",
    content: "With over 20 years of experience in the construction industry, our dedicated team at EBC transforms visions into reality. Whether you're looking to build a dream home, renovate your existing space, or undertake a backyard revamp, we bring expertise, craftsmanship, and attention to detail to every job.",
    mission: "Our commitment to quality and client satisfaction sets us apart. From the initial consultation to the final walkthrough, we work closely with you to ensure your needs and vision are met.",
    vision: "Having the opportunity on past builds to work with exceptional building materials and practices such as Hempcrete, rammed earth, shoshugibon, reclaimed and recycled hardwood, and otsumagaki rendering finishes gives us a unique set of skills that can be applied to your home or project.",
    experience: "20+",
    image: "/images/construction-hero.jpg",
    stats: {
      projectsCompleted: "150+",
      clientSatisfaction: "100%",
      yearsExperience: "20+",
      teamMembers: "50+"
    }
  },
  services: {
    title: "Services",
    items: [
      {
        title: "New Builds",
        description: "Custom home construction with attention to detail and quality craftsmanship."
      },
      {
        title: "Renovations",
        description: "Transform your existing space with our expert renovation services."
      },
      {
        title: "Pools and Landscape",
        description: "Complete outdoor transformations including pool installation and landscape design."
      }
    ]
  },
  contact: {
    title: "Contact Us",
    description: "Contact us today to get started on your dream home.\n\nRyan - Builder: 0416758756\nDaniel - Landscaper: 0422583346\nEmail: Ryan@ebuildandconsult.com\n\nReady to start your next project? Contact our friendly team for a free consultation and quote. Call 0416 758 756 or email Ryan@ebuildandconsult.com."
  }
}; 